export default class FeaturePoint {
    constructor(sensibelPoint) {

        this.featureJson = {
            id: sensibelPoint.walkId,
            type: "Feature",
            geometry: {
                type: "Point",
                coordinates:
                    [
                        sensibelPoint.Lng,
                        sensibelPoint.Lat
                    ],
            },
            properties: {
                walkId: sensibelPoint.walkId,
                pointColor: sensibelPoint.Rating,
                pointCategory: `${sensibelPoint.PosNeg}-${sensibelPoint.PointCategoryTitle}`.replace("/", "-").toLowerCase(),
                type: sensibelPoint.Type,
                imageLink: sensibelPoint.Images[0] ? sensibelPoint.Images[0].ImageLink : "",
                modalImage: sensibelPoint.Images[0] ? sensibelPoint.Images[0].ImageLinkNormal : "",
                description: sensibelPoint.Description ? sensibelPoint.Description : "No description"
            }
        }
    }
}